<template>
	<div
		:class="[customClass != '' ? customClass : 'w-max h-max', isFallback ? 'bg-dj-gray' : '']"
		ref="imageContainer"
	></div>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import { defineComponent, onMounted, ref, watch } from "vue";
import { useCloudinary } from "~/ui-kit/utils";
import cloudinary from "cloudinary-core";

const { Transformation } = cloudinary;

export default defineComponent({
	name: "BaseCloudImage",
	props: {
		publicId: {
			type: String,
			required: true,
		},
		alt: {
			type: String,
			required: true,
			default: "",
		},
		customClass: {
			type: String,
			default: "",
		},
		imageClass: {
			type: String,
			default: "",
		},
		transformation: {
			type: Array,
			default: () => [{ width: 100, height: 100, crop: "scale" }],
		},
		postfix: {
			type: String,
			default: ".jpg",
		},
	},
	emits: ["getUrl", "getSize", "onError"],
	setup(props, { emit }) {
		// Template ref for parent div
		const imageContainer = ref<HTMLElement | null>(null);

		// Create image transformation
		const imageTransformation = new Transformation(props.transformation);

		const isFallback = ref(false);

		let imageTag: HTMLElement;

		function createFallbackTag() {
			isFallback.value = true;
			imageTag = document.createElement("div");
			imageTag.style.cssText += `width: ${props.transformation[0].width}px;height: ${props.transformation[0].height}px`;

			imageContainer.value?.appendChild(imageTag);
		}

		function createImageTag() {
			if (props.publicId) {
				const url = useCloudinary().url(props.publicId + props.postfix);
				emit("getUrl", url);

				imageTag = useCloudinary().image(props.publicId + props.postfix, imageTransformation);

				imageTag.setAttribute("alt", props.alt);

				imageTag.addEventListener("error", () => {
					emit("onError");
				});

				imageTag.addEventListener("load", () => {
					emit("getSize", { height: imageTag.naturalHeight, width: imageTag.naturalWidth });
				});

				if (props.imageClass != "") {
					if (props.imageClass.includes(" ")) {
						props.imageClass.split(" ").map((className) => {
							imageTag.classList.add(className);
						});
					} else {
						imageTag.classList.add(props.imageClass);
					}
				}

				imageContainer.value?.appendChild(imageTag);
			} else {
				createFallbackTag();
			}
		}

		onMounted(() => {
			createImageTag();
		});

		watch(
			() => props.publicId,
			() => {
				if (imageContainer.value) {
					imageContainer.value.innerHTML = "";
					isFallback.value = false;
				}
				createImageTag();
			},
			{ flush: "post" }
		);

		return {
			imageContainer,
			isFallback,
		};
	},
});
</script>
